module.exports = __webpack_public_path__ + "static/media/man.6b5531ac.jpg";